var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RedCircle"},[_c('svg',{staticClass:"RedCircle__svg",attrs:{"viewBox":"0 0 100 100"}},[_c('circle',{ref:"circle",attrs:{"cx":"50","cy":"50","r":"48"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }